module.exports = __webpack_public_path__ + "img/investment-plan.b4b4290c.webp";